const cdnUrl = process.env.GATSBY_CDN_URL
  ? `${process.env.GATSBY_CDN_URL}/files`
  : 'https://cdn.lanl.gov/files';

export const createAssetLink = (assetUrl) =>
  assetUrl &&
  assetUrl.filename_download &&
  `${cdnUrl}/${assetUrl.filename_download}`;
